const utils = require('base_global/utils');
const constants = require('base_global/constants');
var focusHelper = require('base/components/focus');

let pageHeader = '';
let menuWrapper = false;
const isVisibleClass = 'is-visible';
const menuDropdownOpenClass = 'is-dropdown-visible';

var didScroll;
var delta = 5;
var lastScrollTop = 0;
var navbarHeight = '';

let hoverTimeout;
let catBtnMouseHoverTimeout;
let menuCloseTimer = [];
let menuHideTimer = [];
let finallyCloseMenu;
let isNavHover = false;
let currentOpen = [];
let currentTargetId;
let currentTargetMouseLeaveId;

const ACTIVE_NAV_LS_KEY = 'navstate';


/**
 * Get the tallest column and set max-height
 * @param {string} menuitem the container to apply max-height to
 */
function getTallestColumnHeight(menuitem) {
    var maxHeight = menuitem.find('.ds-dropdown-menu .ds-column').outerHeight(true);
    return maxHeight; // Return the inner container height
}

/**
 * loop through mega columns and add a class if it contains content for flex-basis
 */
function checkMegaContent() {
    // remove current class to reset
    $('.ds-column').removeClass('has-slot');

    // loop thru columns checking for visible content
    $('.ds-column .column').each(function () {
        if ($(this).find('.category-asset .html-slot-container').length > 0 && !$(this).find('.category-asset').is(':hidden')) {
            $(this).addClass('has-content');
            $(this).closest('.ds-column').addClass('has-slot');
        }
    });
}

/**
 * Updates the top position of the navigation menu based on header height and scroll position
 * Adjusts menu position differently for mobile and desktop viewports
 */
function applyMenuPositionStyles() {
    // only run this code for small tablet and mobile
    if (!utils.getCurrentBreakpoint().includes('desktop') && $(window).width() < constants.breakpoints.lg) {
        var headerHeight = $('#headerComponent .ds-navbar').outerHeight();
        if (!$('.ds-navbar').hasClass('in-scroll')) {
            headerHeight += $('#headPromoWrapper').is(':visible') ? ($('#headPromoWrapper').outerHeight() - window.scrollY) - 1 : 0;
        }
        $('#nav-main, .mega-wrapper').css('top', headerHeight);
        $('.mega-wrapper').css('height', `calc(var(--vh) - ${headerHeight}px)`);
    }
}

/**
 * Function to activate subcategory
 */
function hasScrolled() {
    var scrollTop = $(window).scrollTop();
    var footComp = $('#footercontent');

    if (Math.abs(lastScrollTop - scrollTop) > 10) {
        $('.js-header-update--mob').addClass('in-scroll').css({
            transition: 'background-color 0.3s cubic-bezier(0.19, 1, 0.22, 1)'
        });
    }
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - scrollTop) <= delta) { return; }

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (scrollTop > lastScrollTop && scrollTop > navbarHeight && scrollTop > 100) {
        $('.js-showpopover').addClass('d-none-popover');
        if (!$('body').hasClass('nav-hidden') && !$('html').hasClass('hide-scroll-and-lock') && !$('.ds-navbar-collapse').hasClass('is-visible')) {
            $('body').addClass('nav-hidden').trigger('nav:updated');
        }

        $('.filtered-list-short').css({
            top: '0px'
        });
    } else if (utils.isInViewport(footComp)) {
        // eslint-disable-next-line no-lonely-if
        // Scroll Up
        if ((scrollTop + $(window).height() < $(document).height()) && scrollTop > 40) {
            if ($('body').hasClass('nav-hidden')) {
                $('body').removeClass('nav-hidden').trigger('nav:updated');
            }

            $('.js-showpopover').addClass('d-none-popover');
            $('.filtered-list-short').css('top', ($('#headerComponent').outerHeight() - 2) + 'px');
            if ($(window).width() < 992 && $(window).width() > 639) {
                $('.js-globalnav-header').css({
                    position: 'fixed'
                });
            }
        } else {
            // Scroll reaches 0
            $('.js-globalnav-header').css({
                position: 'sticky'
            });
            $('.js-header-update--mob').removeClass('in-scroll').css({
                transition: 'background-color 0.4s cubic-bezier(0.19, 1, 0.22, 1)'
            });
        }
    }
    applyMenuPositionStyles();
    lastScrollTop = scrollTop;
}

/**
 * Reset navstate 
 * @returns {boolean}
 */
const resetNavState = () => {
    try {
        // reset navstate from local storage
        localStorage.setItem(ACTIVE_NAV_LS_KEY, '');
        return true;
    } catch (error) {
        console.error('Error resetting nav state:', error);
        return false;
    }
};

/**
 * Get active nav state from localStorage
 * @param {String} [currentPageUrl=location.href] - Current page URL
 * @returns {Object|false} Navigation state object or false if invalid
 */
const getActiveNavItemFromStorage = (currentPageUrl = location.href) => {
    const navState = localStorage.getItem(ACTIVE_NAV_LS_KEY);
    if (!navState) return false;

    // split the nav state to get the id, navItemId and scrollTop
    const [id, navItemLink, scrollTop] = navState.split('|');
    const pdpResetFlag = $('.page.product').length ? true : !currentPageUrl.includes(navItemLink);
    // Reset if nav item doesn't match current category
    if (navItemLink && currentPageUrl && pdpResetFlag) {
        resetNavState();
        return false;
    }

    return { id, scrollTop };
};


/**
 * Open the subnav from the state
 * @param {Object} navState
 * @returns
 */
const openSubNavFromState = (navState) => {
    if (!navState) return;

    const activeNavItem = navState.id;
    const scrollTop = navState.scrollTop || 0;
    if (!activeNavItem) return;

    // add dropdown open class to the menu
    menuWrapper.classList.add(menuDropdownOpenClass);

    // get the main l2 column renference to find the mega wrapper above it
    const $activeNavItem = $(`#${activeNavItem}`);

    const $l2Column = $activeNavItem.parents('.l2-column');
    const $activeNavItemCategoryTitle = $activeNavItem.parents('.category-title');
    const $l3Accordion = $l2Column.length ? $l2Column : $activeNavItemCategoryTitle;

    if (!$l3Accordion.length) return;

    // open the mega wrapper and scroll to the nav link position
    const $megaWrapper = $l3Accordion.parents('.mega-wrapper');
    $megaWrapper.addClass('show');
    $megaWrapper.scrollTop(scrollTop);
    $l3Accordion.addClass('expanded');
};


/**
 * Close the mobile menu
 */
const closeNavbar = () => {
    $(pageHeader).on('click', '.closeMobileMenu', function () {
        $('html').removeClass('hide-scroll-and-lock menu-open nav-hover');
        const $navContainer = $('.mega-wrapper');
        const $navBar = $('.ds-navbar-collapse');
        $navContainer.scrollTop(0);
        menuWrapper.classList.toggle(isVisibleClass);
        $navBar.removeClass(menuDropdownOpenClass);
        $navContainer.removeClass('show');
        $('.l2-column, .category-level2-title, .l3-categories').removeClass('expanded');
        $('.btn-close-icon').hide();
        $('.toggle-menu-mobile').show();
        $('.ds-globalnav-header').removeClass('drawer-open');
        if (!$('.ds-navbar-collapse').hasClass('is-visible')) {
            $('html').removeClass('hide-scroll-and-lock menu-open');
        }
    });
};

/**
 * Open the mobile menu
 */
const openNavbar = () => {
    $(pageHeader).on('click', '.toggle-menu-mobile', function () {
        $('html').addClass('hide-scroll-and-lock menu-open');
        // setTimeout with 0 delay cause this code to run in a different thread and allow time for the menu position to be set
        setTimeout(() => {
            menuWrapper.classList.add(isVisibleClass);
            $('.mega-wrapper').removeClass('show');
            $('.btn-close-icon').show();
            $('.toggle-menu-mobile').hide();

            // get the active natv item from local storage
            openSubNavFromState(getActiveNavItemFromStorage());

            $('.menu__brand-logo').css('display', 'contents');
            $('.ds-globalnav-header').addClass('drawer-open');
        }, 0);
    });

    $('.ds-nav-link, .nav-item__shop-all', '.ds-dropdown-menu').on('click', (e) => {
        const scrollTop = $('.mega-wrapper.show').scrollTop() || 0;
        const linkId = $(e.currentTarget).attr('id');
        const activeNavLink = $(e.currentTarget).attr('href');
        $(".ds-action .reset").trigger("click");
        if (activeNavLink) {
            localStorage.setItem(ACTIVE_NAV_LS_KEY, `${linkId}|${activeNavLink}|${scrollTop}`);
        }
    });
};

/**
 * Gets the screen size of the viewport
 * @return {Object} mobile and desktop
 */
function getViewPortsize() {
    var screenSize = $(window).width();
    var isViewPortAttr;
    var isFontColor;
    if (screenSize <= 768) {
        isViewPortAttr = $('.js-main-menu').attr('data-attr-mob');
        isFontColor = $('.js-main-menu').attr('data-attr-mob-color');
    } else if (screenSize > 768) {
        isViewPortAttr = $('.js-main-menu').attr('data-attr-desk');
        isFontColor = $('.js-main-menu').attr('data-attr-desk-color');
    }
    return { isViewPortAttr, isFontColor };
}


/**
 * apply a max-height of mega based on the viewport height and top distance
 * @return {Object} mobile and desktop
 */
function applyMaxHeight() {
    let headerHeight = $('.ds-navbar').outerHeight();
    let overLapHeight = 30; // dropdown menu overlapping 30px on header
    if (!$('.ds-navbar').hasClass('in-scroll')) {
        headerHeight += $('#headPromoWrapper').is(':visible') ? $('#headPromoWrapper').outerHeight() : 0;
    }
    var viewportHeight = $(window).height();
    var calculatedHeight = viewportHeight - headerHeight;

    // Apply the max-height to the target element
    $('.mega-wrapper').css('max-height', (calculatedHeight + overLapHeight) + 'px');
}


/**
 * Initialize mobile menu event handlers
 * Handles click events for menu items and back navigation
 */
function initializeMobileMenuHandlers() {
    const $leftCatBtn = $('.js-left-catbtn');
    const $megaWrapper = $('.mega-wrapper');
    const $l2Toggle = $('.category-level2-title');
    applyMenuPositionStyles();

    // Loop through each mega-wrapper
    $megaWrapper.each(function () {
        // Find the current mega-wrapper
        var megaWrapper = $(this);

        // Find all the category-asset divs inside the current mega-wrapper
        var categoryAssets = megaWrapper.find('.category-asset');

        // Find the mobilenav-slot-bottom inside the current mega-wrapper
        var mobilenavSlotBottom = megaWrapper.find('.mobilenav-slot-bottom');

        // Append each category-asset to the mobilenav-slot-bottom
        categoryAssets.each(function () {
            if ($(this).has('.html-slot-container').length) {
                mobilenavSlotBottom.append($(this).clone());
            }
        });
    });

    $l2Toggle.each(function () {
        if (!$(this).attr('aria-expanded')) {
            // Dynamically add aria-expanded and aria-controls for mobile view
            $(this).attr('aria-expanded', 'false');

            var content = $(this).next('.l3-categories');
            if (content.length) {
                var linkElement = $(this).find('a.level2-category');
                var linkText = linkElement.text().trim();
                var idValue = 'mobile-acc-' + linkText.replace(/[^\w-]/g, '-').toLowerCase();

                $(this).attr({
                    id: idValue,
                    role: 'button',
                    'aria-controls': idValue + '-content'
                });

                content.attr({
                    'aria-hidden': 'true',
                    'aria-labelledby': idValue,
                    id: idValue + '-content'
                });
            }
        }
    });
    $('body').on('keydown', '.ds-globalnav-header.drawer-open', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '.ds-globalnav-header.drawer-open',
            firstElementSelector: '.closeMobileMenu',
            lastElementSelector: '.minicart-link',
            nextToLastElementSelector: '.acc-popover'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    // Handle menu item clicks
    $leftCatBtn.on('click', function handleMenuClick(e) {
        applyMenuPositionStyles();
        if ($(e.target).closest('.menu-level1, .category-level2-title').length && !$(e.target).hasClass('mob-clickable') && !$(e.target).parent('.category-level2-title').hasClass('level2-nosubs')) {
            e.preventDefault();
        }
        $megaWrapper.removeClass('show');
        $(this).find('.mega-wrapper').addClass('show');
        $('.ds-navbar-collapse').addClass(menuDropdownOpenClass);
    });

    $l2Toggle.on('click', function () {
        const $curElement = $(this);
        var isExpanded = $(this).prop('aria-expanded') === true; // Check current state
        const updateAriaAttributes = (element, expandedState) => {
            element.attr('aria-expanded', !expandedState);
            element.next('.l3-categories').attr('aria-hidden', expandedState);
        };
        if (!$(this).hasClass('level2-nosubs') && !$(this).hasClass('level2-stacked')) {
            $(this).parent('.l2-column').toggleClass('expanded');
            // Handle aria-expanded for the heading (this) and aria-hidden for the content
            updateAriaAttributes($curElement, isExpanded);
        } else if ($(this).hasClass('level2-stacked')) {
            $(this).toggleClass('expanded').next('.l3-categories').toggleClass('expanded');
            // Handle aria-expanded for the heading (this) and aria-hidden for the content
            updateAriaAttributes($curElement, isExpanded);
        }
    });

    // Handle back button clicks in mega nav header
    $(document).on('click', '.mega-nav-header .back-arrow', function handleBackClick(e) {
        e.preventDefault();
        $('.l2-column, .category-level2-title, .l3-categories').removeClass('expanded');
        $('.mega-wrapper').scrollTop(0);
        $(this).closest('.mega-wrapper').removeClass('show');
        $('.ds-navbar-collapse').removeClass(menuDropdownOpenClass);
    });
}

/**
 * Opens a mega menu with animation and accessibility features
 * @param {HTMLElement} menuElem - The menu element to be opened
 * @param {string} elementId - Unique identifier for the menu element, used for styling
 * @param {boolean} isKeyboard - Flag indicating if the menu was triggered by keyboard interaction
 * @description
 * This function handles the opening of mega menu elements by:
 * - Setting the height based on the tallest column
 * - Managing CSS classes for animations
 * - Updating ARIA attributes for accessibility
 * - Handling scroll visibility
 * - Adding unique styling classes for shop categories
 * - Managing menu state and transitions
 */
function openMenu(menuElem, elementId, isKeyboard) {
    var tallestHeight = getTallestColumnHeight($(menuElem));  // Pass $(this) as the container
    var megaHeightBuffer = 5;
    const $allCatBtn = $('.js-left-catbtn');

    applyMaxHeight(); // apply max-height dynamically
    if (isKeyboard) $allCatBtn.not(menuElem).removeClass('show');
    $('.js-left-catbtn').removeClass('scroll-visible');
    clearTimeout(hoverTimeout);
    $(menuElem).addClass('show').removeClass('hiding');
    $(menuElem).find('.ds-nav-link.menu-level1, .nav-dropdown-icon').attr('aria-expanded', 'true');
    $(menuElem).find('.ds-dropdown-menu').css('min-height', tallestHeight);
    $('.js-left-catbtn').find('.mega-wrapper').css('height', tallestHeight + megaHeightBuffer);

    if (parseInt($(menuElem).find('.ds-dropdown-menu').css('min-height'), 10) > parseInt($(menuElem).find('.mega-wrapper').css('max-height'), 10)) {
        $(menuElem).addClass('scroll-visible');
    }

    // add hover class with unique ID to header nave for content team to update design on sale nav and nav footer
    if (elementId) {
        $(menuElem).closest('.ds-globalnav-header').addClass('shopcat-' + elementId);
    }

    setTimeout(() => {
        $(menuElem).addClass('showing');
    }, constants.TIMEOUT.MENU_SHOW);

    currentOpen = [];
    currentOpen.push(currentTargetId);
}

export default {
    init: function () {
        pageHeader = document.querySelector('.header');
        menuWrapper = pageHeader.querySelector('.ds-navbar-collapse') || false;
        navbarHeight = $('.js-globalnav-header').outerHeight();

        $(window).on('load', function () {
            hasScrolled();
        });

        $('.nav-item a').on('mouseover', function () {
            var elementId = $(this).attr('id') || '';

            if (elementId) {
                elementId = elementId.toLowerCase();
            }

            // remove hover class with unique ID to column parent
            $(this).closest('.column').removeClass(function (index, className) {
                return (className.match(/\bhover-\S+/g) || []).join(' ');
            });

            // add hover class with unique ID to column parent
            if (elementId) {
                $(this).closest('.column').addClass('hover-' + elementId);
            }
        });

        if (utils.getCurrentBreakpoint() !== 'mobile') {
            // check for content columns for grid colspan
            checkMegaContent();

            $('.js-left-catbtn').on('mouseover keydown', function (e) {
                currentTargetId = e.currentTarget && e.currentTarget.id;
                const isKeyboard = e.type === 'keydown';
                let elementId = $(this).find('.menu-level1').attr('id') || '';

                if (currentOpen.includes(currentTargetId)) {
                    // this means the menu is already open and we should cancel any new open
                    clearTimeout(catBtnMouseHoverTimeout);
                    clearTimeout(finallyCloseMenu);
                    clearTimeout(menuCloseTimer[currentTargetId]);
                    clearTimeout(menuHideTimer[currentTargetId]);

                    // there is a chance that the menu just started to close half way,
                    // so if it comes into this block we should put back the show classes
                    openMenu($(`#${currentTargetId}`)[0], elementId, isKeyboard);
                    return;
                }

                if (e.type === 'keydown' && e.which !== 13) return;
                if ($(this).hasClass('show')) return;

                const $hoverTab = $(this).attr('id');
                const $subCatName = $(this).text();

                if (elementId) {
                    elementId = elementId.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
                }

                // remove hover class with unique ID to column parent
                $(this).closest('.ds-globalnav-header').removeClass(function (index, className) {
                    return (className.match(/\bshopcat-\S+/g) || []).join(' ');
                });

                // any time mouse is over the list item add class as it going to open the menu
                $('html').addClass('hide-scroll-and-lock menu-open');

                // add show from menu item if open through keyboard or in tab
                if (e.type === 'keydown' || utils.getCurrentBreakpoint() === 'tablet') {
                    $(this).parent('.ds-navbar-nav').addClass('show');
                }

                // Clear any existing mouseleave timeouts
                clearTimeout(catBtnMouseHoverTimeout);
                clearTimeout(finallyCloseMenu);

                // add show class with delay to have animation working
                catBtnMouseHoverTimeout = setTimeout(() => {
                    openMenu(this, elementId, isKeyboard);
                }, constants.TIMEOUT.MENU_SHOW);
            }).on('mouseleave', function (e) {
                currentTargetMouseLeaveId = e.currentTarget && e.currentTarget.id;

                // Reset mega wrapper height and remove show class on mouse leave
                clearTimeout(catBtnMouseHoverTimeout);

                // add hiding class with delay to have animation working
                menuHideTimer[currentTargetMouseLeaveId] = setTimeout(() => {
                    // if mouse is still over nav do not remove else clear it
                    if (!isNavHover) {
                        $('.mega-wrapper').css({ height: 0 });
                    }
                    $(this).addClass('hiding');
                }, constants.TIMEOUT.MENU_ITEM_HIDE_PREP);

                // Remove show and aria attributes when mouse leaves
                // the delay is for the transition between two menu and avoid jump
                menuCloseTimer[currentTargetMouseLeaveId] = setTimeout(() => {
                    $(this)
                    .removeClass('show hiding showing')
                    .find('.ds-nav-link.menu-level1').attr('aria-expanded', 'false');
                    $(this).find('.nav-dropdown-icon').attr('aria-expanded', 'false');
                }, constants.TIMEOUT.MENU_ITEM_HIDE);

                // no interaction menu is close height removed
                finallyCloseMenu = setTimeout(() => {
                    const $allCatBtn = $('.js-left-catbtn');
                    // Remove show class from all and add show to hover item.
                    $allCatBtn.removeClass('show showing hiding');

                    $('.ds-nav-link.menu-level1, .nav-dropdown-icon').attr('aria-expanded', 'false');
                    $('.mega-wrapper').css({ height: 0 });
                    $('.ds-dropdown-menu').css({ minHeight: 0 });

                    // remove menu-open when mouse out
                    $('html').removeClass('hide-scroll-and-lock menu-open');

                    // if mouse is still over nav do not remove else clear it
                    if (!isNavHover) $('html').removeClass('nav-hover');

                    // reset current open array
                    currentOpen = [];
                }, constants.TIMEOUT.MENU_CLOSE);

                // remove hover class with unique ID to column parent
                $(this).closest('.ds-globalnav-header').removeClass(function (index, className) {
                    return (className.match(/\bshopcat-\S+/g) || []).join(' ');
                });
            });

            $('.js-left-catbtn').on('focus focusin', function () {
                var $link = $(this);
                if ($link.hasClass('ds-dropdown')) {
                    // Add functionality for Enter key
                    $link.on('keydown', function (e) {
                        if ((e.which === 13 || e.keyCode === 13) && e.target === this) {
                            e.preventDefault(); // Prevent default action
                            // Shift focus to the .mega-wrapper div
                            $('.mega-wrapper').focus();
                        }
                    });
                }
            });
        } else {
            initializeMobileMenuHandlers();
        }

        // check viewport before intializing
        if (utils.getCurrentBreakpoint() === 'mobile') {
            utils.initializeSlider($('.promoBanner--mobile'), {
                prevArrow:
                    '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style=""><span class="icon-prev icon-chevron-left"></span></button>',
                nextArrow:
                    '<button class="slick-next slick-arrow slick-disabled" aria-label="Next" type="button" aria-disabled="true" style=""><span class="icon-next icon-chevron-right"></span></button>'
            });
            // this logic runs without delay in mobile view
            $('.ds-navbar-nav > li').on('mouseenter', function (e) {
                $('html').addClass('hide-scroll-and-lock menu-open');
            }).on('mouseleave', function (e) {
                if (!$('.ds-navbar-collapse').hasClass('is-visible')) {
                    $('html').removeClass('hide-scroll-and-lock menu-open nav-hover');
                }
            });
        }

        // idenfier to know if the mouse is over nav for transparency purpose
        $('.ds-globalnav-header').on('mouseenter', function () {
            isNavHover = true;
            $('html').addClass('nav-hover nav-hovering');
        }).on('mouseleave', function () {
            isNavHover = false;
            $('html').removeClass('nav-hovering');
            if (!$('html').hasClass('menu-open')) {
                $('html').removeClass('nav-hover');
            }
        });

        // FIXME: this code seems not needed
        $('.ds-navbar-nav').on('mouseover mouseleave keydown focusin focusout', function (e) {
            if (e.type === 'mouseover') {
                hoverTimeout = setTimeout(() => {
                    $(this).addClass('show');
                }, 300);
            }
            if (e.type === 'focusin') {
                hoverTimeout = setTimeout(() => {
                    $(this).addClass('show');
                }, 100);
            }

            if (e.type === 'mouseleave' || (e.type === 'keydown' && e.which === 27) || e.type === 'focusout') {
                clearTimeout(hoverTimeout);
                clearTimeout(catBtnMouseHoverTimeout);
                $(this).removeClass('show');
            }
        });

        // to show peeky header on scroll up
        $(window).on('scroll', function () {
            didScroll = true;
        });

        // check for mega content on resize
        $(window).on('resize', function () {
            checkMegaContent();
        });

        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        /* Account show changes */
        $(document).on('click', function (e) {
            var $showPopover = $('.js-showpopover');
            if ($(e.target).parents('.js-acc-btn').length) {
                $showPopover.toggleClass('d-none-popover');
            } else if (!$showPopover.hasClass('d-none-popover')) {
                $showPopover.addClass('d-none-popover');
            }

            var accountElm = $('.js-showpopover .reg-acc-name');
            $('.reg-acc-name').on('click', function (event) {
                event.stopPropagation();
            });
            if (accountElm.width() > $showPopover.width()) {
                accountElm.hide();
            }
        });

        setTimeout(() => {
            if (getViewPortsize().isViewPortAttr === 'true') {
                $('.ds-navbar').addClass('transparent__background');
                if (getViewPortsize().isFontColor === 'white') {
                    $('.ds-navbar').addClass('color-white');
                } else {
                    $('.ds-navbar').addClass('color-black');
                }
                $('.storepage.plp-page').css('padding-top', '80px');
            }
        }, 5);
    },

    openNavbar: openNavbar,
    closeNavbar: closeNavbar
};
